// :cow: Cosmose CONFIDENTIAL :iso:
import { Injectable } from '@angular/core';
import { DateRangeFilter } from '@coa/app/shared/filters/select-date-range/models/date-range-filter';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DashboardSummary } from '../models/dashboard-summary';
import { ConfigService } from '@coa/app/core/services/config.service';

@Injectable({
  providedIn: 'root',
})
export class DashboardSummaryService {

  constructor(
    private httpClient: HttpClient,
    private configService: ConfigService,
  ) {
  }

  getSummary(timePeriod: DateRangeFilter, clientId: string, categoryId?: string): Observable<DashboardSummary> {
    const url = `${ this.configService.getConfig().analyticsApi }/dashboard/summary`;
    let params = new HttpParams({
      fromObject: {
        timePeriod, clientId: clientId.toString(),
      },
    });

    if (categoryId) {
      params = params.append('categoryId', categoryId);
    }

    return this.httpClient.get<DashboardSummary>(url, {params});
  }
}
